import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Seo, { Breadcrumbs } from "@/components/Seo";
import { Clock, ArrowRight } from "lucide-react";

export default function Guides() {
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data)).catch(() => {});
  }, []);

  return (
    <div className="container-bl py-10" data-testid="page-guides">
      <Seo
        title="Rental Guides · B&L Rentals · Oxnard, CA"
        description="Long-form guides on renting vans and vehicles in Oxnard and Ventura County — insurance, pricing, pickup tips, and the best local group trips."
        canonical={typeof window !== "undefined" ? window.location.origin + "/guides" : undefined}
      />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Guides" }]} />

      <div className="max-w-3xl">
        <div className="text-sm uppercase tracking-widest text-[#E2AB20] font-semibold">Guides</div>
        <h1 className="mt-2 text-4xl sm:text-5xl font-heading font-bold text-white">
          Ventura County rental guides
        </h1>
        <p className="mt-3 text-[#AEB9C9]">
          Practical, host-written guides on how to book, insure, and get the most out of your rental in Oxnard and the surrounding Ventura County towns.
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {guides.length === 0 && (
          <div className="col-span-full card-bl p-10 text-center text-[#AEB9C9]" data-testid="guides-empty">
            More guides coming soon.
          </div>
        )}
        {guides.map((g) => (
          <Link
            key={g.slug}
            to={`/guides/${g.slug}`}
            data-testid={`guide-card-${g.slug}`}
            className="card-bl group transition-transform hover:-translate-y-1 hover:shadow-md flex flex-col"
          >
            <div className="aspect-[16/9] overflow-hidden bg-gray-100">
              <img
                src={g.hero_image}
                alt={g.hero_alt || g.title}
                title={g.hero_alt || g.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-xs text-[#AEB9C9]">
                <span className="flex items-center gap-1"><Clock size={12} /> {g.read_minutes} min read</span>
                <span>·</span>
                <span>{g.published_at}</span>
              </div>
              <h2 className="mt-2 font-heading font-semibold text-lg text-white leading-snug line-clamp-3">
                {g.title}
              </h2>
              <p className="mt-2 text-sm text-[#AEB9C9] line-clamp-3">{g.excerpt}</p>
              <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                <span className="text-xs text-[#AEB9C9]">By {g.author}</span>
                <span className="text-xs text-[#E2AB20] font-semibold inline-flex items-center gap-1">
                  Read guide <ArrowRight size={12} />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
